import { characterActionTypes } from "@dndbeyond/character-rules-engine/es";

import { mapAbilityScoreTypeSet } from "./mappers/abilityScores";
import {
  mapBackgroundHasCustomSet,
  mapBackgroundHasCustomSetCommit,
  mapBackgroundSetCommit,
} from "./mappers/background";
import { mapClassAdd } from "./mappers/classAdd";
import { mapClassLevelSet } from "./mappers/classLevel";
import { mapPreferenceChoose } from "./mappers/settings";
import { mapRaceChoose } from "./mappers/species";
import type { CharacterActionMappers, ClickElementMappers } from "./middleware";

/**
 * Builder actions that are sent as CHARACTER_ACTION events, keyed by action
 * type (for example `characterActionTypes.CLASS_ADD_REQUEST`).
 *
 * Map the intent actions (`*_REQUEST`, `*_CHOOSE`) rather than their
 * `*_COMMIT` counterparts so each user interaction is sent once. Map a commit
 * only when the intent doesn't carry enough to describe the change, and
 * compare the state before it so unrelated saves aren't sent.
 */
export const characterActionMappers: CharacterActionMappers = {
  [characterActionTypes.CLASS_ADD_REQUEST]: mapClassAdd,
  [characterActionTypes.CLASS_LEVEL_SET_REQUEST]: mapClassLevelSet,
  [characterActionTypes.RACE_CHOOSE]: mapRaceChoose,
  [characterActionTypes.BACKGROUND_SET_COMMIT]: mapBackgroundSetCommit,
  [characterActionTypes.BACKGROUND_HAS_CUSTOM_SET_COMMIT]:
    mapBackgroundHasCustomSetCommit,
  [characterActionTypes.BACKGROUND_HAS_CUSTOM_SET_REQUEST]:
    mapBackgroundHasCustomSet,
  [characterActionTypes.ABILITY_SCORE_TYPE_SET_REQUEST]: mapAbilityScoreTypeSet,
};

/**
 * Builder actions that are sent as CLICK_ELEMENT events
 */
export const clickElementMappers: ClickElementMappers = {
  [characterActionTypes.PREFERENCE_CHOOSE]: mapPreferenceChoose,
};
